export default __webpack_public_path__ + "static/media/search-bank.dea43cae.svg";